module.exports = __webpack_public_path__ + "img/agen-naik-kelas.9f074c4c.svg";